module.exports = __webpack_public_path__ + "static/media/embedded-hero.d5d3e0cb.jpg";